import { Disclosure } from "@headlessui/react";
import { MenuIcon, XIcon, ArrowLeftIcon } from "@heroicons/react/outline";
import { useState, useRef, useEffect } from "react";
import { Link, useLocation, useNavigate } from "react-router-dom";

export default function Navbars() {
  const [drawerOpen, setDrawerOpen] = useState(false);
  const location = useLocation();
  const navigate = useNavigate();
  const drawerRef = useRef(null); 
  const menuButtonRef = useRef(null); 

  const toggleDrawer = () => {
    setDrawerOpen(!drawerOpen);
  };

  useEffect(() => {
    setDrawerOpen(false);
  }, [location.pathname])

  const handleBackButtonClick = () => {
    navigate(-1); 
  };

  const handleRefresh = () => {
    window.location.reload();
  };

  const logout=()=>{
    sessionStorage.removeItem("response");
    sessionStorage.removeItem("tokens");
    navigate("/");
  }

  // const showBackButton = location.pathname === "/";
  // const showBackButton = location.pathname === "/pdfextracter" || location.pathname.startsWith("/update/") ;
  // const showBackButton = location.pathname === "/pdfextracter2" || location.pathname.startsWith("/") ;
  const showBackButton = !(location.pathname === "/");

  

  useEffect(() => {
    const handleClickOutside = (event) => {
      if (
        drawerRef.current &&
        !drawerRef.current.contains(event.target) &&
        menuButtonRef.current &&
        !menuButtonRef.current.contains(event.target)
      ) {
        setDrawerOpen(false);
      }
    };

    document.addEventListener("mousedown", handleClickOutside);
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, []);

  return (
    <>
      {/* Navbar */}
      <Disclosure as="nav" className="bg-gray-800 fixed top-0 left-0 w-full z-[100]">
        {({ open }) => (
          <>
            <div className="mx-auto px-2 sm:px-6 lg:px-8 ">
              <div className="relative flex items-center justify-between h-16 space-x-3">
                {/* Menu button (Visible on both large and small screens) */}
            {showBackButton &&   <div className="pl-2 flex items-center lg:text-left absolute inset-y-0 left-0 flex items-center">
                  <button
                    ref={menuButtonRef}
                    onClick={toggleDrawer}
                    className="inline-flex items-center justify-center p-2 rounded-md text-gray-400 hover:text-white hover:bg-gray-700 focus:outline-none focus:ring-2 focus:ring-inset focus:ring-white"
                  >
                    <span className="sr-only">Open main menu</span>
                    {drawerOpen ? (
                      <XIcon className="block h-6 w-6" aria-hidden="true" />
                    ) : (
                      <MenuIcon className="block h-6 w-6" aria-hidden="true" />
                    )}
                  </button>
                </div>}

                {/* Logo */}
                <div className="flex-1 pl-12 flex items-center sm:items-stretch sm:justify-start">
                  <div className="flex-shrink-0 flex items-center">
                    <img
                      className="hidden lg:block h-10 w-auto"
                      src="https://www.khindia.com/assets/images/KH_Logo.png"
                      alt="Logo"
                    />
                    <img
                      className="block lg:hidden h-10 w-auto"
                      src="https://www.khindia.com/assets/images/KH_Logo.png"
                      alt="Logo"
                    />
                  </div>
                </div>

                {/* Back button (Visible only on specific routes) */}
                {/* {showBackButton && (
                    <button onClick={handleRefresh} className=" bg-gray-400 text-white py-1 px-4 rounded-lg shadow hover:bg-indigo-600">
                    Clear
                  </button>
                )} */}
                  {showBackButton && (
                    <button onClick={logout} className=" bg-gray-400 text-white py-1 px-4 rounded-lg shadow hover:bg-indigo-600">
                    Logout
                  </button>
                )}
              </div>
            </div>
          </>
        )}
      </Disclosure>

      {/* Drawer Menu (Toggles open/close) */}
      <div
        ref={drawerRef}
        id="drawer-navigation"
        className={`fixed top-0 left-0 z-40 h-screen p-4 overflow-y-auto transition-transform bg-gray-600 w-64 dark:bg-gray-800 ${
          drawerOpen ? "translate-x-0" : "-translate-x-full"
        }`}
        tabIndex="-1"
        aria-labelledby="drawer-navigation-label"
      >
        <h5
          id="drawer-navigation-label"
          className="text-base font-semibold text-gray-500 uppercase dark:text-gray-400"
        >
          Menu
        </h5>
        <button
          type="button"
          onClick={toggleDrawer}
          className="text-gray-400 bg-transparent hover:bg-gray-200 hover:text-gray-900 rounded-lg text-sm w-8 h-8 absolute top-2.5 right-2.5 inline-flex items-center justify-center dark:hover:bg-gray-600 dark:hover:text-white"
        >
          <svg
            className="w-3 h-3"
            aria-hidden="true"
            xmlns="http://www.w3.org/2000/svg"
            fill="none"
            viewBox="0 0 14 14"
          >
            <path
              stroke="currentColor"
              strokeLinecap="round"
              strokeLinejoin="round"
              strokeWidth="2"
              d="m1 1 6 6m0 0 6 6M7 7l6-6M7 7l-6 6"
            />
          </svg>
          <span className="sr-only">Close menu</span>
        </button>
        
        <div className="mt-5 py-4 overflow-y-auto">
          <ul className="space-y-2 font-medium">
          {/* <li>
              <Link to={`/pdfextracter2`} className="flex items-center p-2 text-white rounded-lg dark:text-white ">
                <svg
                  className="w-5 h-5 text-white transition duration-75 dark:text-gray-400 group-hover:text-gray-900 dark:group-hover:text-white"
                  aria-hidden="true"
                  xmlns="http://www.w3.org/2000/svg"
                  fill="currentColor"
                  viewBox="0 0 22 21"
                >
                  <path d="M16.975 11H10V4.025a1 1 0 0 0-1.066-.998 8.5 8.5 0 1 0 9.039 9.039.999.999 0 0 0-1-1.066h.002Z"/>
                  <path d="M12.5 0c-.157 0-.311.01-.565.027A1 1 0 0 0 11 1.02V10h8.975a1 1 0 0 0 1-.935c.013-.188.028-.374.028-.565A8.51 8.51 0 0 0 12.5 0Z"/>
                </svg>
                <span className="ms-3">Pdf Split</span>
              </Link>
            
            </li>
            <hr className="border w-full block"></hr> */}
            <li>
            {/* <Link to={`/temp`} className="flex items-center p-2 text-white rounded-lg dark:text-white ">
                <svg
                  className="w-5 h-5 text-white transition duration-75 dark:text-gray-400 group-hover:text-gray-900 dark:group-hover:text-white"
                  aria-hidden="true"
                  xmlns="http://www.w3.org/2000/svg"
                  fill="currentColor"
                  viewBox="0 0 22 21"
                >
                  <path d="M16.975 11H10V4.025a1 1 0 0 0-1.066-.998 8.5 8.5 0 1 0 9.039 9.039.999.999 0 0 0-1-1.066h.002Z"/>
                  <path d="M12.5 0c-.157 0-.311.01-.565.027A1 1 0 0 0 11 1.02V10h8.975a1 1 0 0 0 1-.935c.013-.188.028-.374.028-.565A8.51 8.51 0 0 0 12.5 0Z"/>
                </svg>
                <span className="ms-3">Pdf Split 1</span>
              </Link>
            
            </li>
            <hr className="border w-full block"></hr>
            <li> */}
            <Link to={`/temp2`} className="flex items-center p-2 text-white rounded-lg dark:text-white ">
                <svg
                  className="w-5 h-5 text-white transition duration-75 dark:text-gray-400 group-hover:text-gray-900 dark:group-hover:text-white"
                  aria-hidden="true"
                  xmlns="http://www.w3.org/2000/svg"
                  fill="currentColor"
                  viewBox="0 0 22 21"
                >
                  <path d="M16.975 11H10V4.025a1 1 0 0 0-1.066-.998 8.5 8.5 0 1 0 9.039 9.039.999.999 0 0 0-1-1.066h.002Z"/>
                  <path d="M12.5 0c-.157 0-.311.01-.565.027A1 1 0 0 0 11 1.02V10h8.975a1 1 0 0 0 1-.935c.013-.188.028-.374.028-.565A8.51 8.51 0 0 0 12.5 0Z"/>
                </svg>
                <span className="ms-3">PDF Split</span>
              </Link>
            
            </li>
            <hr className="border w-full block"></hr>
           
            <li>
              <Link to={`/grid`} className="flex items-center p-2 text-white rounded-lg dark:text-white ">
                <svg
                  className="w-5 h-5 text-white transition duration-75 dark:text-gray-400 group-hover:text-gray-900 dark:group-hover:text-white"
                  aria-hidden="true"
                  xmlns="http://www.w3.org/2000/svg"
                  fill="currentColor"
                  viewBox="0 0 22 21"
                >
                  <path d="M16.975 11H10V4.025a1 1 0 0 0-1.066-.998 8.5 8.5 0 1 0 9.039 9.039.999.999 0 0 0-1-1.066h.002Z"/>
                  <path d="M12.5 0c-.157 0-.311.01-.565.027A1 1 0 0 0 11 1.02V10h8.975a1 1 0 0 0 1-.935c.013-.188.028-.374.028-.565A8.51 8.51 0 0 0 12.5 0Z"/>
                </svg>
                <span className="ms-3">S3 Missing Img Report</span>
              </Link>
            </li>
            <hr className="border w-full block"></hr>
            {/* <li>
              <Link to={`/pdfextracter2`} className="flex items-center p-2 text-white rounded-lg dark:text-white ">
                <svg
                  className="w-5 h-5 text-white transition duration-75 dark:text-gray-400 group-hover:text-gray-900 dark:group-hover:text-white"
                  aria-hidden="true"
                  xmlns="http://www.w3.org/2000/svg"
                  fill="currentColor"
                  viewBox="0 0 22 21"
                >
                  <path d="M16.975 11H10V4.025a1 1 0 0 0-1.066-.998 8.5 8.5 0 1 0 9.039 9.039.999.999 0 0 0-1-1.066h.002Z"/>
                  <path d="M12.5 0c-.157 0-.311.01-.565.027A1 1 0 0 0 11 1.02V10h8.975a1 1 0 0 0 1-.935c.013-.188.028-.374.028-.565A8.51 8.51 0 0 0 12.5 0Z"/>
                </svg>
                <span className="ms-3">split pdf</span>
              </Link>
            </li>
            <hr className="border w-full block"></hr> */}
          </ul>
        </div>
      </div>

    
      <main className="pt-16">{/* Your page content here */}</main>
    </>
  );
}
